<template>
    <div class="wrapper">
        <section id="officeHours">
            <h2>Office Hours</h2>

            <custom-input type="toggle" name="toggleCrisisMessage" label="Turn on/off" v-model="enabled"/>

            <section v-show="enabled">
                <div v-for="(openingTime, index) in openingTimes" class="office-hour" v-bind:key="index">
                    <div class="grid">
                        <label>{{ openingTime.day }}</label>
                        <custom-input type="toggle" :name="openingTime.name + 'StartToggle'" v-model="openingTime.open"/>

                        <section :class="!openingTime.open ? 'hidden' : ''">
                            <custom-input type="time" :id="openingTime.name + 'Start'" :name="openingTime.name + 'Start'" placeholder="start" v-model="openingTime.start" @input="validateOfficeHours(openingTime, false)"/>
                            <custom-input type="time" :id="openingTime.name + 'End'" :name="openingTime.name + 'End'" placeholder="end" v-model="openingTime.end" @input="validateOfficeHours(openingTime, false)"/>
                        </section>

                        <div class="errors" v-show="openingTime.open" v-if="$validator.errors && $validator.errors.has(openingTime.name)">
                            <small v-for="(error, index) in $validator.errors.collect(openingTime.name)" v-bind:key="index">
                                {{ error }}
                            </small>
                        </div>
                    </div>
                </div>

                <div class="messages">
                    <custom-input type="textarea" name="outOfOfficeMessageNL" ref="outOfOfficeMessageNL" label="Out Of Office Message - NL" placeholder="Message" v-model="outOfOfficeMessage.NL" :validationRules="{required: true}"/>
                    <custom-input type="textarea" name="outOfOfficeMessageEN" ref="outOfOfficeMessageEN" label="Out Of Office Message - EN" placeholder="Message" v-model="outOfOfficeMessage.EN" :validationRules="{required: true}"/>
                </div>
            </section>
        </section>

        <button class="primary" @click="saveConfig">Save</button>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput';
import dateformat from 'dateformat';

export default {
    name: 'settingsOfficeHours',
    mixins: [
        Default
    ],
    components: {
        customInput
    },
    inject: {
        $validator: '$validator'
    },
    data() {
        return {
            blockValidation: true,
            enabled: false,
            openingTimes: [
                {
                    start: '',
                    end: '',
                    name: 'openingTimeMonday',
                    day: 'Monday',
                    open: false
                },
                {
                    start: '',
                    end: '',
                    name: 'openingTimeTuesday',
                    day: 'Tuesday',
                    open: false
                },
                {
                    start: '',
                    end: '',
                    name: 'openingTimeWednesday',
                    day: 'Wednesday',
                    open: false
                },
                {
                    start: '',
                    end: '',
                    name: 'openingTimeThursday',
                    day: 'Thursday',
                    open: false
                },
                {
                    start: '',
                    end: '',
                    name: 'openingTimeFriday',
                    day: 'Friday',
                    open: false
                },
                {
                    start: '',
                    end: '',
                    name: 'openingTimeSaturday',
                    day: 'Saturday',
                    open: false
                },
                {
                    start: '',
                    end: '',
                    name: 'openingTimeSunday',
                    day: 'Sunday',
                    open: false
                }
            ],
            outOfOfficeMessage: {
                NL: '',
                EN: ''
            }
        };
    },
    mounted() {
        this.blockValidation = false;
        this.getConfig();
    },
    methods: {
        validateOOOMessages: function() {
            return new Promise((resolve) => {
                this.$parleyAdmin.validateMultiple([this.$refs.outOfOfficeMessageNL, this.$refs.outOfOfficeMessageEN], function(value) {
                    if (!value) {
                        this.$refs.outOfOfficeMessageNL.toggleErrors(true);
                        this.$refs.outOfOfficeMessageEN.toggleErrors(true);
                    }

                    resolve(value);
                }.bind(this));
            });
        },
        validateOfficeHours: function(model, checkForEmpty) {
            if (this.blockValidation)
                return false;

            this.$validator.errors.remove(model.name);

            if (!model.open) // If time is closed we don't have to check the time
                return true;

            if (checkForEmpty && !(model.start && model.end)) {
                this.$validator.errors.add({
                    field: model.name,
                    msg: 'Invalid time range'
                });
                return false;
            }

            if ((model.start && model.end) && model.start >= model.end) {
                this.$validator.errors.add({
                    field: model.name,
                    msg: 'Invalid time range'
                });
                return false;
            } else
                return true;
        },
        openingTimeToString: function(openingTime) {
            const start = dateformat(new Date(openingTime.start), 'HH:MM');
            const end = dateformat(new Date(openingTime.end), 'HH:MM');
            return start + '-' + end;
        },
        openingTimeToObject: function(openingTime) {
            if (!openingTime)
                return false;

            let start = openingTime.split('-')[0];
            let startHours = start.split(':')[0];
            let startMinuts = start.split(':')[1];
            let startDate = new Date();
            startDate.setHours(startHours);
            startDate.setMinutes(startMinuts);

            let end = openingTime.split('-')[1];
            let endHours = end.split(':')[0];
            let endMinuts = end.split(':')[1];
            let endDate = new Date();
            endDate.setHours(endHours);
            endDate.setMinutes(endMinuts);

            return {
                start: startDate.toISOString(),
                end: endDate.toISOString()
            };
        },
        saveConfig: async function() {
            // Prepare office hours
            let formattedOpeningTimes = [];
            if (this.enabled) {
                let failed = false;
                this.openingTimes.forEach((openingTime) => {
                    if (!openingTime.open)
                        formattedOpeningTimes.push('');
                    else {
                        const result = this.validateOfficeHours(openingTime, true);
                        if (!result)
                            failed = true;
                        else
                            formattedOpeningTimes.push(this.openingTimeToString(openingTime));
                    }
                });

                if (failed)
                    return;

                // Validate OOO messages
                let validOOOMessages = await this.validateOOOMessages();
                if (!validOOOMessages)
                    return;
            } else {
                // Reset times by supplying empty string
                this.openingTimes.forEach(() => {
                    formattedOpeningTimes.push('');
                });

                // Reset text as well
                this.outOfOfficeMessage.NL = '';
                this.outOfOfficeMessage.EN = '';
            }

            return new Promise((resolve) => {
                return this.$http.put('v1.1/config', {
                    openingTimeMonday: formattedOpeningTimes[0],
                    openingTimeTuesday: formattedOpeningTimes[1],
                    openingTimeWednesday: formattedOpeningTimes[2],
                    openingTimeThursday: formattedOpeningTimes[3],
                    openingTimeFriday: formattedOpeningTimes[4],
                    openingTimeSaturday: formattedOpeningTimes[5],
                    openingTimeSunday: formattedOpeningTimes[6],
                    outOfOfficeTextNL: this.outOfOfficeMessage.NL,
                    outOfOfficeTextEN: this.outOfOfficeMessage.EN
                }).then(response => {
                    // Success callback
                    if (!response.data.data.success)
                        this.$parleyAdmin.queryErrors.addError('Something went wrong while saving the office hours configuration, please try again later');
                    else
                        this.$parleyAdmin.queryErrors.addError('Office hours configuration saved successfully', this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
                    resolve(true);
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while saving the office hours configuration, please try again later');
                    resolve(false);
                });
            });
        },
        getConfig: function() {
            return new Promise((resolve) => {
                return this.$http.get('v1.1/config').then(response => {
                    // Success callback

                    // Save office hours
                    let keys = Object.keys(response.data.data).filter(setting => { return setting.startsWith('openingTime'); });
                    keys.forEach((key, index) => {
                        const openingTimeObject = this.openingTimeToObject(response.data.data[key]);

                        if (!openingTimeObject)
                            return false;

                        this.openingTimes[index].start = openingTimeObject.start;
                        this.openingTimes[index].end = openingTimeObject.end;
                        this.openingTimes[index].open = true;

                        this.enabled = true; // We have data so enable
                    });

                    // Also enable when we have text
                    if (response.data.data.outOfOfficeTextNL || response.data.data.outOfOfficeTextNL)
                        this.enabled = true;

                    // Save out of office message
                    this.outOfOfficeMessage.NL = response.data.data.outOfOfficeTextNL;
                    this.outOfOfficeMessage.EN = response.data.data.outOfOfficeTextEN;

                    resolve(true);
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while retrieving the office hours configuration, please try again later');
                    resolve(false);
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .wrapper {
        width: 50%;
        max-width: 34em;

        section {
            margin-bottom: 1em;
        }

        #officeHours {
            .office-hour {
                margin-bottom: 0.5em;
                margin-right: 1em;

                .grid {
                    display: grid;
                    grid-template-columns: 7em 4em auto;
                    grid-template-rows: auto auto;

                    .toggle {
                        position: relative;
                        top: .5em;
                    }

                    .toggle,
                    .custom-input {
                        padding-bottom: 0;
                    }

                    label,
                    section {
                        margin: auto 0;
                    }

                    section {
                        .custom-input {
                            width: 8em;
                            display: inline-block;

                            &:nth-child(2) {
                                margin-left: .5em;
                            }
                        }

                        &.hidden {
                            opacity: 0;
                        }
                    }

                    .errors {
                        grid-column: 3;
                    }
                }
            }

            .messages {
                margin-top: 2em;
            }
        }

        .errors {
            color: red;
        }
    }
</style>

<style lang="scss">
    .wrapper {
        section {
            .custom-input {
                .time-input {
                    text-align: center;
                }
            }
        }
    }
</style>
